// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.otp_otp-container__BuKc7 {
}
.otp_otp-inner__GkIiU {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 16px;
  position: relative;
  flex-direction: column;
  gap: 40px;
}
.otp_otp-inputs-box__zqX0u {
  display: flex;
  gap: 18px;
  justify-content: center;
  align-items: center;
  direction: ltr;
}
.otp_otp-inputs-box__zqX0u input {
  display: flex;
  justify-content: center;
  align-items: center;
  outline: 2px solid transparent;
  outline-offset: 2px;
  border-radius: 8px;
  border: 1px solid rgba(240, 240, 240, 0.5);
  background: rgba(255, 255, 255, 0.1);
  width: 20%;
  height: 48px;
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 171.429% */
}
.otp_otp-inputs-box__zqX0u input:focus {
  border: 1px solid #ff97d2;
}
.otp_error__lRezN {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  position: relative;
}
.otp_error__lRezN span {
  position: absolute;
  top: 9px;
  right: 0;
  color: #ff9d9d;
  text-align: right;
  font-size: 12px;
  font-style: normal;
  font-weight: 325;
  line-height: 20px;
}
.otp_frame__iD9Ht {
}
.otp_edit__qNZAx {
  display: flex;
  justify-content: center;
  align-items: center;
}
.otp_edit__qNZAx button {
  color: #fff;
  text-align: right;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}
.otp_try__XUaiq {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 14px;
}
.otp_try-title__aViXy {
  font-size: 14px;
}
.otp_try-box__AWcVm {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  gap: 6px;
}
.otp_try-sms__NNnoY {
  border-radius: 20px;
  background: rgba(243, 243, 243, 0.2);
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  width: 163px;
  height: 40px;
}
.otp_try-call__6aW6f {
  border-radius: 50%;
  background: rgba(243, 243, 243, 0.2);
  color: #fff;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.otp_try__XUaiq button {
}
.otp_timer__prxLF {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 20px;
  background: rgba(243, 243, 243, 0.2);
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  width: 205px;
  height: 40px;
}
.otp_timer-text__Bh-Mj {
}
.otp_timer-counter__hXo3Y {
}
.otp_title__4xoCi {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin-bottom: 24px;
}
.otp_title__4xoCi span {
  color: #fff;
  text-align: right;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}
.otp_down-box__Mxr9H {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.otp_down-box-inner__GzQg7 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.otp_submit__c0BLp {
}
.otp_submit__c0BLp span {
  font-size: 16px;
}
.otp_otp-inputs-box__zqX0u input::placeholder {
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 171.429% */
}
.otp_call-box__q4-Z\\+ {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 38px;
}
.otp_top-box__mG1D6 {
}
.otp_credentioal__zXxt3 {
  opacity: 0;
  position: absolute;
  z-index: -1;
}
@media screen and (min-width: 1200px) {
  .otp_otp-inner__GkIiU {
    min-height: 300px;
    max-height: 400px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/login/otp.module.css"],"names":[],"mappings":"AAAA;AACA;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EAEnB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,oCAAoC;EACpC,UAAU;EACV,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;AACA;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;AACA;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,YAAY;AACd;AACA;AACA;AACA;AACA;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA;AACA;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;AACA;AACA;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;AACA;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF","sourcesContent":[".otp-container {\n}\n.otp-inner {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 0 16px;\n  position: relative;\n  flex-direction: column;\n  gap: 40px;\n}\n.otp-inputs-box {\n  display: flex;\n  gap: 18px;\n  justify-content: center;\n  align-items: center;\n  direction: ltr;\n}\n.otp-inputs-box input {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n  border-radius: 8px;\n  border: 1px solid rgba(240, 240, 240, 0.5);\n  background: rgba(255, 255, 255, 0.1);\n  width: 20%;\n  height: 48px;\n  color: #fff;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px; /* 171.429% */\n}\n.otp-inputs-box input:focus {\n  border: 1px solid #ff97d2;\n}\n.error {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  width: 100%;\n  position: relative;\n}\n.error span {\n  position: absolute;\n  top: 9px;\n  right: 0;\n  color: #ff9d9d;\n  text-align: right;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 325;\n  line-height: 20px;\n}\n.frame {\n}\n.edit {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.edit button {\n  color: #fff;\n  text-align: right;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n}\n.try {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 14px;\n}\n.try-title {\n  font-size: 14px;\n}\n.try-box {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 12px;\n  gap: 6px;\n}\n.try-sms {\n  border-radius: 20px;\n  background: rgba(243, 243, 243, 0.2);\n  color: #fff;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 28px;\n  width: 163px;\n  height: 40px;\n}\n.try-call {\n  border-radius: 50%;\n  background: rgba(243, 243, 243, 0.2);\n  color: #fff;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.try button {\n}\n.timer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  border-radius: 20px;\n  background: rgba(243, 243, 243, 0.2);\n  color: #fff;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  width: 205px;\n  height: 40px;\n}\n.timer-text {\n}\n.timer-counter {\n}\n.title {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  margin-bottom: 24px;\n}\n.title span {\n  color: #fff;\n  text-align: right;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n}\n.down-box {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.down-box-inner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n.submit {\n}\n.submit span {\n  font-size: 16px;\n}\n.otp-inputs-box input::placeholder {\n  color: #fff;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px; /* 171.429% */\n}\n.call-box {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  margin-top: 38px;\n}\n.top-box {\n}\n.credentioal {\n  opacity: 0;\n  position: absolute;\n  z-index: -1;\n}\n@media screen and (min-width: 1200px) {\n  .otp-inner {\n    min-height: 300px;\n    max-height: 400px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"otp-container": `otp_otp-container__BuKc7`,
	"otp-inner": `otp_otp-inner__GkIiU`,
	"otp-inputs-box": `otp_otp-inputs-box__zqX0u`,
	"error": `otp_error__lRezN`,
	"frame": `otp_frame__iD9Ht`,
	"edit": `otp_edit__qNZAx`,
	"try": `otp_try__XUaiq`,
	"try-title": `otp_try-title__aViXy`,
	"try-box": `otp_try-box__AWcVm`,
	"try-sms": `otp_try-sms__NNnoY`,
	"try-call": `otp_try-call__6aW6f`,
	"timer": `otp_timer__prxLF`,
	"timer-text": `otp_timer-text__Bh-Mj`,
	"timer-counter": `otp_timer-counter__hXo3Y`,
	"title": `otp_title__4xoCi`,
	"down-box": `otp_down-box__Mxr9H`,
	"down-box-inner": `otp_down-box-inner__GzQg7`,
	"submit": `otp_submit__c0BLp`,
	"call-box": `otp_call-box__q4-Z+`,
	"top-box": `otp_top-box__mG1D6`,
	"credentioal": `otp_credentioal__zXxt3`
};
export default ___CSS_LOADER_EXPORT___;
